export default "__VITE_ASSET__Bd_x9F0s__"